// https://engineering.udacity.com/handling-errors-like-a-pro-in-typescript-d7a314ad4991
import * as React from "react";
import { StatusTypes } from "src/models/types/StatusTypes";
// import StateContext from 'src/context/UserProvider';
import IFloatingPanel from "../models/interfaces/IFloatingPanel";

/**
 * title ----------------- message
 * subtitle -------------- name
 * typeMessage ----------- status
 * description ----------- cause
 * descriptionCollapse --- stack
 **/
export class EDPError extends Error {
  status: StatusTypes;

  constructor(
    message: string,
    status: StatusTypes,
    name: string | undefined = undefined,
    stack: any | undefined = undefined,
    cause: any = undefined
  ) {
    super(message); // (1)
    this.name = name ? name : this.name; // (2)
    this.stack = stack;
    this.status = status;
    this.cause = cause;
  }
}

function ErrorService(error: EDPError): void {
  // const { setError } = StateContext();
  console.clear();

  const data: IFloatingPanel = {
    title: error.name,
    subtitle: error.message,
    typeMessage: error.status
  }

  if (error.cause) data.description = <>`${error.cause}`</>;
  if (error.stack) data.descriptionCollapse = <>`${error.stack}`</>;

  // setError(data);
  // TODO Enviar mensaje al server.
  console.log(error);
}

export default ErrorService;
